import AnalyticsTabBar from './analyticsTabBar';

export default AnalyticsTabBar;